import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    const [active, setActive] = useState("home");
    function scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    return <>

        {/* <!-- Footer --> */}
        <footer id="footer" className="footer layer-overlay overlay-dark-9" data-tm-bg-img="images/bg/bg2.jpg" style={{ backgroundImage: `url('images/bg/bg2.jpg')` }}>
            <div className="footer-widget-area">
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="tm-widget-contact-info contact-info-style1 contact-icon-theme-colored1">
                                <div className="thumb">
                                    <img alt="Logo" src="images/horizontal-logo-footer.png" />
                                </div>
                                <div className="description">We provide high-quality courses and training services tailored to healthcare professionals. </div>
                            </div>
                            <ul className="styled-icons icon-dark icon-theme-colored1 icon-rounded clearfix">
                                <li><Link className="social-link" to="https://www.facebook.com/SGHAcademy?mibextid=9R9pXO" ><i className="fab fa-facebook"></i></Link></li>
                                <li><Link className="social-link" to="https://www.linkedin.com/company/saudigermanacademy/" ><i className="fab fa-linkedin"></i></Link></li>
                                {/* <li><Link className="social-link" to="" ><i className="fab fa-youtube"></i></Link></li> */}
                                <li><Link className="social-link" to="https://www.instagram.com/sgacademyy/" ><i className="fab fa-instagram"></i></Link></li>
                            </ul>
                        </div>


                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="widget widget_nav_menu">
                                <h4 className="widget-title widget-title-line-bottom line-bottom-theme-colored1">Quick Links</h4>
                                <ul>
                                    <li><Link className={`${active === "about" ? "active" : ""}`} to="/about" onClick={() => {
                                        scrollToTop();
                                        setActive("about")
                                    }}>About Us</Link></li>
                                    <li><Link className={`${active === "Courses" ? "active" : ""}`} to="/courses" onClick={() => {
                                        scrollToTop();
                                        setActive("courses")
                                    }}>Courses</Link></li>
                                    <li><Link className={`${active === "calender" ? "active" : ""}`} to="/training-events-calender" onClick={() => {
                                        scrollToTop();
                                        setActive("calender")
                                    }}>Our calendar</Link></li>
                                    <li><Link className={`${active === "media" ? "active" : ""}`} to="/media-center" onClick={() => {
                                        scrollToTop();
                                        setActive("media")
                                    }}>Media Center</Link></li>
                                    <li><Link className={`${active === "contact" ? "active" : ""}`} to="/contact-us" onClick={() => {
                                        scrollToTop();
                                        setActive("contact")
                                    }}>Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="widget">
                                <h4 className="widget-title widget-title-line-bottom line-bottom-theme-colored1">Contact US</h4>
                                <div className="latest-posts">
                                    <article className="post clearfix pb-0 mb-20">
                                        <Link className="post-thumb w-auto" to=""><i class="flaticon-contact-047-location font-icon sm-display-block"></i> </Link>
                                        <div className="post-right">
                                            <h5 className="post-title mt-0"><Link to="" className='fw-bold'>Address</Link></h5>
                                            <span className="post-date">
                                                <time>47,Josef Teto street - Nozha, Heliopolis, Cairo, Egypt</time>
                                            </span>
                                        </div>
                                    </article>
                                    <article className="post clearfix pb-0 mb-20">
                                        <Link className="post-thumb w-auto" to=""><i className="flaticon-contact-043-email-1 font-icon sm-display-block"></i></Link>
                                        <div className="post-right">
                                            <h5 className="post-title mt-0"><Link to="" className='fw-bold'>Email</Link></h5>
                                            <span className="post-date">
                                                <time>info@saudigermanacademy.com</time>
                                            </span>
                                        </div>
                                    </article>
                                    {/* <article className="post clearfix pb-0 mb-20">
                                        <Link className="post-thumb w-auto" to=""><i className="flaticon-contact-042-phone-1 text-theme-color-2 mr-5"></i> </Link>
                                        <div className="post-right">
                                            <h5 className="post-title mt-0"><Link to="" className='fw-bold'>Phone</Link></h5>
                                            <span className="post-date">
                                                <time>01202777706 - 01201879408</time>
                                            </span>
                                        </div>
                                    </article> */}
                                    <article className="post clearfix pb-0 mb-20">
                                        <Link className="post-thumb w-auto" to=""><i className="flaticon-contact-042-phone-1 font-icon sm-display-block"></i> </Link>
                                        <div className="post-right">
                                            <h5 className="post-title mt-0"><Link to="" className='fw-bold'>HotLine</Link></h5>
                                            <span className="post-date">
                                                <time>16259</time>
                                            </span>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="widget">
                                <h4 className="widget-title widget-title-line-bottom line-bottom-theme-colored1">Working Hours</h4>
                                <div className="opening-hours border-dark">
                                    <ul>
                                        <li className="clearfix"> <span> Saturday - Thursday</span>
                                            <div className="value float-end flip"> 9.00 am - 5.00 pm </div>
                                        </li>

                                        <li className="clearfix"> <span> Friday</span>
                                            <div className="value float-end flip"> Closed </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom" data-tm-bg-color="#2A2A2A">
                    <div className="container">
                        <div className="row pt-20 pb-20">
                            <div className="col-sm-6">
                                <div className="footer-paragraph">
                                    © 2025 Saudi German Academy. All Rights Reserved.
                                </div>
                            </div>
                            {/* <div className="col-sm-6">
                                <div className="footer-paragraph text-right">
                                    Site Template
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <Link className="scrollToTop" to=""><i className="fa fa-angle-up"></i></Link>
    </>

}
